import { FormikContextType, useFormikContext } from "formik";

import type { TOrderFormData } from "../models/orderForm";

const useOrderFormik = (): FormikContextType<TOrderFormData> => useFormikContext<TOrderFormData>();
export default useOrderFormik;
